import React from "react";
import { INavBarIconInterface } from "../Helpers/types";

export default function IconComment(props: INavBarIconInterface) {
  return (
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4 0H2.6C1.17 0 0 1.17 0 2.6V18.2C0 19.63 1.17 20.8 2.6 20.8H20.8L26 26V2.6C26 1.17 24.83 0 23.4 0ZM23.4 2.6V19.721L21.879 18.2H2.6V2.6H23.4ZM5.2 13H20.8V15.6H5.2V13ZM20.8 9.1H5.2V11.7H20.8V9.1ZM5.2 5.2H20.8V7.8H5.2V5.2Z"
        className={props.selected ? "fill-brij-Mud" : "fill-brij-Default"}
      ></path>
    </svg>
  );
}
